import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig } from './config';

/**
 * Singleton MSAL instance.
 *
 * MSAL v3+ forbids calling any API (getAllAccounts, getActiveAccount, …)
 * before `initialize()` resolves. So this module must not touch the
 * instance at import time beyond construction + event-callback
 * registration. Bootstrap lives in `main.tsx` after
 * `initialize() + handleRedirectPromise()`.
 */
export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.addEventCallback((event) => {
  if (
    event.eventType === EventType.LOGIN_SUCCESS &&
    event.payload &&
    'account' in event.payload &&
    event.payload.account
  ) {
    msalInstance.setActiveAccount(event.payload.account);
  }
});
